// extracted by mini-css-extract-plugin
module.exports = {"dibsvg-svg":"_62b9fddd","dibsvgSvg":"_62b9fddd"};